<template>
  <v-autocomplete
    v-model="selectedItem"
    @update:search-input="handleInput"
    :filter="filterObject"
    :loading="accountLoading"
    :items="accountItems"
    item-value="id"
    class="account-connection-autocomplete"
    :label="isEmployee ? 'Account for employee' : 'Account for customer'"
    item-text="fullName"
    :dense="dense"
    return-object
    clean
    clearable
    outlined
    hide-details>
    <template v-slot:item="{ props, item }">
      <div class="d-flex flex-column gap-2">
        <div>
          <strong>{{ item.fullName }}</strong>
        </div>
        <div style="font-size: 14px">
          {{ item.email }}
        </div>
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import AuthApi from "@/services/auth.api";
import router from "@/router";
import store from "@/store";

export default {
  name: "AccountAutoComplete",
  emits: ["modelChange"],
  components: {},
  props: {
    initItem: {
      type: Object,
      default: () => ({}),
    },
    isEmployee: {
      type: Boolean,
      default: false,
    },
    accountForCustomers: {
      type: Array,
      default: () => [],
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    accountLoading: false,
    selectedItem: null,
    searchedAccounts: [],
    typingTimer: null,
    accountNotFoundState: false,
    token: null,
    lastSearchId: 0,
  }),
  watch: {
    initItem: {
      immediate: true,
      deep: true,
      handler(initItem) {
        const account = initItem?.account?.id ? initItem.account : null;
        if (account?.id === this.selectedItem?.id) return;
        this.selectedItem = account;
      },
    },

    selectedItem(value) {
      this.$emit("modelChange", value || null);

      if (value?.id) {
        this.searchedAccounts = [];
        this.accountNotFoundState = false;
      }
    },
  },
  mounted() {
    this.getToken();
  },

  computed: {
    AuthModel() {
      return new AuthApi(this.token);
    },

    accountItems() {
      if (this.searchedAccounts.length || this.accountNotFoundState) {
        return this.searchedAccounts;
      }

      if (this.selectedItem?.id) {
        return [this.selectedItem];
      }

      return this.accountForCustomers;
    },
  },
  methods: {
    handleInput(value) {
      clearTimeout(this.typingTimer);

      const selectedText = this.selectedItem?.fullName;

      if (value && selectedText && value === selectedText) {
        return;
      }

      if (!value) {
        this.lastSearchId++;
        this.searchedAccounts = [];
        this.accountNotFoundState = false;
        this.accountLoading = false;
        return;
      }

      this.typingTimer = setTimeout(() => {
        this.getAccountList(value);
      }, 300);
    },

    async getToken() {
      this.token = await store.dispatch("auth/acquireToken", router.history.current.meta.scopes);
    },

    filterObject(item, queryText, itemText) {
      return true;
    },

    async getAccountList(query = null) {
      const searchId = ++this.lastSearchId;

      const params = {
        includeDeleted: false,
        q: query,
      };

      this.accountLoading = true;

      try {
        const response = await this.AuthModel.accountList(params);

        if (searchId !== this.lastSearchId) return;

        this.searchedAccounts = response.data.filter((account) => !account.isDeleted);
        this.accountNotFoundState = !this.searchedAccounts.length;
      } catch (error) {
        if (searchId !== this.lastSearchId) return;

        console.error(error);
        this.searchedAccounts = [];
        this.accountNotFoundState = true;
      } finally {
        if (searchId === this.lastSearchId) {
          this.accountLoading = false;
        }
      }
    },
  },
};
</script>
